import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null,
};

const earlyBirdOfferReducer = createReducer(initialState, {
  USER_EARLY_BIRD_OFFER_REQ: (state) => {
    state.loading = true;
    state.data = null;
  },
  USER_EARLY_BIRD_OFFER_FETCH_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  USER_EARLY_BIRD_OFFER_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default earlyBirdOfferReducer;
